import React from "react";
import {ReactComponent as MicrosoftLogo} from "../../../images/icons/microsoft-logo.svg";
import "../../../css/navigation.scss"

const LoginPopup = React.forwardRef(({shown}, ref) => {
    return (
        <div ref={ref} className={"popup-area" + (shown ? " shown" : "")}>
            <button className="popup-button microsoft" onClick={() => window.location.href = "/oauth2/authorization/microsoft"}>
                <MicrosoftLogo/>
                <span>Sign in with Microsoft</span>
            </button>
        </div>
    );
});

export default LoginPopup;
